import { Maybe } from '@codegrade/maybe';
import { typeHelpers } from '@codegrade/utils';
import * as utils from '@codegrade/utils';
import { coerceToString } from './string';
export * from './string';
export * from './boolean';
export * from './api';
export * from './vue';
export * from './error';
export * from './debug';
export * from './set';
export * from './expr';
export * from './number';
export * from './range';
/** @inheritdoc */
export { escape as htmlEscape } from './html';
export * as api from './api';
export * as signal from './signal';
export * as props from './props';
export * as visualize from './visualize';
export * as search from './search';
export * as element from './element';
export * as expr from './expr';
export * as user from './user';
export * as transaction from './transaction';
/**
 * @deprecated Don't use this class.
 * @inheritdoc
 */
export class AssertionError extends utils.assert.AssertionError {
}
/**
 * @deprecated Don't use these exports.
 * @inheritdoc
 */
export const { capitalize, concatString, splitEscapableString, toOrdinal } = utils.string;
/** @inheritdoc */
export const { loadAllPages } = utils.api;
/**
 * @deprecated Don't use these exports.
 * @inheritdoc
 */
export const { butLast, ensureArray, flat1, findMax, findMaybe, findMaybeIndex, findMin, last, partition, partitionMap, shuffle, sumMap, trim, unzip2, } = utils.array;
/**
 * @deprecated Don't use these exports.
 * @inheritdoc
 */
export const { epoch, formatDate, formatMoment, formatNullableDate, getMaximumMoment, getMinimumMoment, momentUtc, readableFormatDate, toMoment, toMomentMaybe, toMomentNullable, } = utils.datetime;
/**
 * @deprecated Don't use these exports.
 * @inheritdoc
 */
export const { keysOfFast, keysOfSlow } = utils.typeHelpers;
/**
 * @deprecated Don't use these exports.
 * @inheritdoc
 */
export const { attr, filterMap, filterObject, forEachObject, fromEntries, getItem, hasAttr, isObject, makeCompleteLookupMapping, makeCompleteLookupMapping2, makeLookupMapping, mapFilterObject, mapObject, mapToObject, unionAttr, } = utils.object;
/**
 * @deprecated Don't use these exports.
 * @inheritdoc
 */
export const { sortBy } = utils.sort;
/**
 * @deprecated Don't use these exports.
 * @inheritdoc
 */
export const { immutable } = utils.immutable;
/**
 * @deprecated Don't use these exports.
 * @inheritdoc
 */
export const { dirName, splitPath } = utils.path;
/**
 * @deprecated Don't use these exports.
 * @inheritdoc
 */
export const { groupBy, flatMap1, readableJoin } = utils.itertools;
/**
 * @deprecated Don't use these exports.
 * @inheritdoc
 */
export { either as eitherUtils, eitherAsync as eitherAsyncUtils, maybe as maybeUtils, compare, datetime, decode, humanize, itertools, } from '@codegrade/utils';
/**
 * @deprecated Don't use these exports.
 * @inheritdoc
 */
export const { coerceToError } = utils.errors;
if (!IS_PRODUCTION) {
    import('./signal').then(signal => {
        // @ts-expect-error: Typescript doesn't allow us to add stuff
        // to window.
        window.cgSignals = signal;
    });
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function isinstance(typ) {
    return (obj) => obj instanceof typ;
}
/**
 * Convert an array to the same array with only unique values.
 *
 * @param arr The array to convert.
 * @param getKey The callback to get a key that can be compared.
 * @returns The same array with only unique values.
 * @deprecated Use `utils.itertools.unique` instead.
 */
export function unique(arr, getKey) {
    return Array.from(utils.itertools.unique(getKey, arr));
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function buildUrl(parts, args = {}) {
    let mainPart;
    let initialSlash = '';
    if (typeof parts === 'string') {
        mainPart = parts;
    }
    else {
        initialSlash = '/';
        mainPart = parts.map(part => encodeURIComponent(coerceToString(part))).join('/');
    }
    const addTrailingSlash = args.addTrailingSlash;
    if (addTrailingSlash ?? false) {
        mainPart = `${mainPart}/`;
    }
    let prefix = '';
    if (args.protocol != null) {
        initialSlash = '/';
        utils.assert.AssertionError.typeAssert(args.baseUrl);
        prefix = `${args.protocol.toString()}//${args.host.toString()}`;
    }
    else if (args.baseUrl != null) {
        utils.assert.AssertionError.typeAssert(args.protocol);
        utils.assert.AssertionError.typeAssert(args.host);
        prefix = args.baseUrl;
        if (prefix.endsWith('/')) {
            prefix += '/';
        }
    }
    let query = '';
    if (args.query != null) {
        const queryEntries = Object.entries(args.query);
        if (queryEntries.length > 0) {
            const params = queryEntries
                .reduce((acc, [key, value]) => {
                acc.append(key, coerceToString(value));
                return acc;
            }, new URLSearchParams())
                .toString();
            query = `?${params}`;
        }
    }
    let hash = '';
    if (args.hash != null && args.hash !== '') {
        hash = `#${encodeURIComponent(args.hash)}`;
    }
    return `${prefix}${initialSlash}${mainPart}${query}${hash}`;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const getUniqueId = utils.helpers.makeUniqueCounter();
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function waitAtLeast(time, ...promises) {
    const timeout = new Promise(resolve => {
        setTimeout(resolve, time);
    });
    return Promise.all([timeout, Promise.all(promises)]).then(([_, vals]) => {
        if (promises.length === 1) {
            return vals[0];
        }
        else {
            return vals;
        }
    });
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function getProps(obj, defaultValue, ...props) {
    let res = obj;
    for (let i = 0; res != null && i < props.length; ++i) {
        res = res[props[i]];
    }
    if (res == null) {
        return defaultValue;
    }
    return res;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function deepEquals(a, b) {
    if (typeof a !== 'object') {
        return a === b;
    }
    else if (a == null || b == null) {
        // eslint-disable-next-line eqeqeq
        return a == b;
    }
    else if (typeof b !== 'object') {
        return false;
    }
    else {
        const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
        for (const key of keys) {
            if (!deepEquals(a[key], b[key])) {
                return false;
            }
        }
        return true;
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function isEmpty(obj) {
    if (typeof obj !== 'object' || obj == null) {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        return !obj;
    }
    else {
        return Object.keys(obj).length === 0;
    }
}
/**
 * Check if the user matches the filter we have supplied.
 *
 * @param user The user we need to check.
 * @param filter The filter that is supplied.
 * @returns Whether the user supplied matches the filter in some way.
 */
export function userMatches(user, filter) {
    // The given user might not be an actual user object, as this function is
    // also used by the plagiarism list.
    const terms = [
        user.type === 'normal' ? user.name.orDefault('') : user.group.name,
        user.username,
    ];
    return filter
        .toLocaleLowerCase()
        .split(' ')
        .every(word => terms.some(term => term.includes(word)));
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function hashString(str) {
    let hash = 0;
    if (str.length === 0)
        return hash;
    for (let i = 0; i < str.length; i++) {
        const character = str.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash &= hash; // Convert to 32bit integer
    }
    return Math.abs(hash << 0);
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function cmpOneNull(first, second) {
    if (first == null && second == null) {
        return null;
    }
    else if (first == null) {
        return -1;
    }
    else if (second == null) {
        return 1;
    }
    return null;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function cmpNoCase(first, second) {
    return coerceToString(first).localeCompare(coerceToString(second), undefined, {
        sensitivity: 'base',
    });
}
/**
 * Compare many 2-tuples of strings stopping at the first tuple that is not
 * equal.
 *
 * @param opts An array of arrays with two items.
 * @returns The comparison result.
 */
export function cmpNoCaseMany(...opts) {
    let res = 0;
    for (let i = 0; res === 0 && i < opts.length; ++i) {
        res = cmpNoCase(...opts[i]);
    }
    return res;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function deepCopy(value, maxDepth = 10, depth = 1) {
    if (depth > maxDepth) {
        throw new Error('Max depth reached');
    }
    if (Array.isArray(value)) {
        return value.map(v => deepCopy(v, maxDepth, depth + 1));
    }
    else if (value != null && typeof value === 'object') {
        return Object.entries(value).reduce((res, [k, v]) => {
            res[k] = deepCopy(v, maxDepth, depth + 1);
            return res;
        }, {});
    }
    else {
        return value;
    }
}
/**
 * Test if a given string is a valid http or https url.
 *
 * @param input The input to check for.
 * @returns A boolean if the input is a http(s) url.
 */
export const isValidHttpUrl = (() => {
    const STARTS_WITH_HTTPS = /^https?/;
    const URL_PATTERN = new RegExp([
        '^(https?:\\/\\/)', // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|', // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))', // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*', // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?', // query string
        '(\\#[-a-z\\d_]*)?$', // maybe a hash
    ].join(''), 'i');
    return (input) => {
        if (URL_PATTERN.test(input)) {
            // URL only is too lenient (`new URL('https://a')` is fine), but we
            // use it as an extra check to make sure the regex above is never
            // allowing things that `URL` doesn't think is a URL.
            let url;
            try {
                url = new URL(input);
            }
            catch (_) {
                return false;
            }
            return !!STARTS_WITH_HTTPS.test(url.protocol);
        }
        return false;
    };
})();
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function groupByIter(arr, mapper, compareFunc) {
    const eq = utils.compare.Order.EQ;
    return arr
        .map((x, idx) => [mapper(x, idx), idx, x])
        .sort(([a, idxA], [b, idxB]) => {
        let valueOrder = compareFunc(a, b);
        // Make sure sort order is stable.
        if (valueOrder === eq) {
            valueOrder = utils.compare.compare(idxA, idxB);
        }
        return utils.compare.orderToNumber(valueOrder);
    })
        .reduce((acc, [key, _, value]) => {
        if (acc.length > 0 && compareFunc(acc[acc.length - 1][0], key) === eq) {
            acc[acc.length - 1][1].push(value);
        }
        else {
            acc.push([key, [value]]);
        }
        return acc;
    }, []);
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function formatTimePart(num) {
    return `${num < 10 ? '0' : ''}${num}`;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function getPropMaybe(obj, prop) {
    const res = obj?.[prop];
    if (Maybe.isMaybe(res)) {
        return res;
    }
    else {
        return Maybe.fromNullable(res);
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function pickKeys(obj, keys, strict = true) {
    return keys.reduce((acc, key) => {
        if (strict || Object.prototype.hasOwnProperty.call(obj, key)) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function getExternalUrl() {
    return window.location.origin;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function urlSameOrigin(url) {
    if (url.startsWith('/')) {
        return true;
    }
    try {
        return new URL(url).origin === getExternalUrl();
    }
    catch {
        return false;
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function stripURLOrigin(url) {
    if (url.startsWith('/')) {
        return url;
    }
    const urlObj = new URL(url);
    const origin = urlObj.origin;
    return urlObj.href.slice(origin.length);
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function getProxyBaseDomain() {
    return `proxy.${window.location.host}`;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function getCssVariable(variable) {
    return getComputedStyle(document.body).getPropertyValue(variable);
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const ELLIPSIS = '\u2026';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function maybeAttributeOrEllipsis(value, attribute) {
    const maybeAttr = value.map(v => v[attribute]);
    return maybeAttr.orDefault(ELLIPSIS);
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function getMaybe(map, key) {
    return Maybe.fromNullable(map.get(key));
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function not(x) {
    return !x;
}
/* eslint-disable-next-line @typescript-eslint/no-empty-function, jsdoc/require-jsdoc -- When touching please add documentation. */
export function discard() { }
const timeframeLikeKeys = typeHelpers.keysOfFast(['availability', 'deadline', 'lockDate']);
/**
 * Check whether two timeframes are equal.
 *
 * @param a The first timeframe.
 * @param b The second timeframe.
 * @returns Whether `a` and `b` are equal.
 */
export function timeframeLikeEqual(a, b) {
    return timeframeLikeKeys.every(key => utils.expr.switcher(key, {
        availability: () => utils.expr.match(a.availability, 'tag', {
            fixed: ({ value }) => b.availability.tag === 'fixed' && b.availability.value === value,
            timed: ({ availableAt }) => b.availability.tag === 'timed' &&
                b.availability.availableAt.isSame(availableAt),
        }),
        deadline: () => utils.compare.compare(a.deadline, b.deadline) === utils.compare.Order.EQ,
        lockDate: () => utils.compare.compare(a.lockDate, b.lockDate) === utils.compare.Order.EQ,
    }));
}
